import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { useTheme } from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { FC } from 'react'
import type { CareQuestionOption } from '../../hooks/useCareQuestionOptions'

/**
 * Care question option card
 */
export const CareQuestionOptionCta: FC<CareQuestionOption & { onClose: () => void }> = ({
  label,
  icon,
  onClick,
  onClose,
  color,
}) => {
  const theme = useTheme()

  if (!color) {
    color = theme.Colors.Neutrals.Darkest
  }

  const handleClick = () => {
    onClick()
    onClose()
  }

  return (
    <StOptionContainer onClick={handleClick}>
      <Flex gap={theme.UI.Spacing.Space3} alignItems='center'>
        {icon ? (
          typeof icon === 'object' && 'path' in icon ? (
            <img src={icon.path} alt={icon.alt} />
          ) : (
            <FontAwesomeIcon icon={icon} color={color} />
          )
        ) : null}
        <Span type='BodyMediumRegular' color={color} style={{ fontWeight: 400 }}>
          {label}
        </Span>
      </Flex>

      <FontAwesomeIcon icon={['far', 'chevron-right']} color={color} />
    </StOptionContainer>
  )
}

const StOptionContainer = styled(Flex)`
  justify-content: space-between;
  align-items: center;

  padding: ${({ theme }) => theme.UI.Spacing.Space4}px;

  cursor: pointer;

  flex: 1;
`
